import React from 'react'
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { SUBSCRIPTION_API } from '../../services/common/endpoints';
import SubscriptionsUnsubscribe from './subscriptions-unsubscribe';
import Loadingcomponent from '../loader/loadingcomponent';
import { getImgSrc } from '../../services/common/CommonUtils';

function Subscriptions({ psmItem }) {
    const { t } = useTranslation();

    const subscriptionApi = useQuery(
        ["subscriberprofile", SUBSCRIPTION_API, { msisdn: "" }, {}],
        {
            retry: false,
            retryOnMount: false,
            cacheTime: 0,
            staleTime: 0,
        }
    );

    if (subscriptionApi.isLoading) {
        return <Loadingcomponent />
    }

    if (subscriptionApi?.data?.data?.response?.services?.length === 0 || subscriptionApi?.data?.data?.status === '-1') {
        return <></>
    }

    return (
        <>
            <div class="white_card dashboard_card mt-30 sprint14-blance-info">
                <div>
                    <div class="balance_section_info">
                        <h5>{psmItem?.elementmeta?.title || ''}</h5>

                        <div class="sprint14-2row">

                            {
                                subscriptionApi?.data?.data?.response?.services?.map((item, index, arr) => {
                                    return (
                                        <>
                                            <div class="profile_info_desc">
                                                <div class="d-flex align-item-center">
                                                    <img src={getImgSrc(item?.imageurl || item?.image, true)}
                                                        alt="service-icon" height={45} />
                                                    <div class="s-text me-2">
                                                        <h5>{item?.name}</h5>
                                                        <p class="m-0 p-0"> {t('renon')}: {item.rnexpirationdate} </p>
                                                    </div>
                                                </div>
                                                <div class="event_img d-flex">
                                                    <div class="cs_toggle_btn">
                                                        <SubscriptionsUnsubscribe item={item} />
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                (index + 1) !== arr.length && (
                                                    <hr />
                                                )
                                            }
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Subscriptions